export const initialHomeDevicesState = {
    devicesById: {},
    deviceIdsByHomeId: {},
};
